import config from '../config';
// import * as createjs from 'createjs-module';
import { Tree } from '../graphics/Tree';
// import { ActionMap } from '../graphics/ActionMap';
import { renderTree, displayTypes } from '../graphics/cjs-lib';
// import { createTween } from '../components/Animation';

let initialState = {
  width: 600,
  height: 600
};

if (config.useNativeCanvas) {
  initialState.items = [];
} else {
  initialState.actionIds = [];
  initialState.tweenItems = [];
  initialState.handlers = [];
  initialState.actionMap = null;
}

export default function rootReducer(state = initialState, action) {
  if (config.useNativeCanvas) {
    return canvasReducer(state, action);
  }
  return cjsReducer(state, action);
}

function cjsReducer(state, action) {
  const { canvas, stage, tree, actionIds, tweenItems, handlers, actionMap } = state;
  let newActionIds = Array.isArray(actionIds) ? actionIds.slice() : [];
  const { payload } = action;
  if ( payload instanceof Object) {
    const {
      id, value, parentId, updatedTree, handler, type, newActionMap,
      actionId, removedActionId, tweenItem, removedTweenItem, items
    } = payload;
    console.log('reducer', action.type);
    let newTweenItems = tweenItems.slice(0);
    if (tweenItem) {
      if (!tweenItems.find(item => item.tweenId === tweenItem.tweenId)) {
        newTweenItems.push(tweenItem);
      }
    }
    if (removedTweenItem) {
      const index = tweenItems.findIndex(item => item.tweenId === removedTweenItem.tweenId);
      if (index >= 0) {
        newTweenItems.splice(index, 1);
      }
    }
    if (!newActionIds.includes(actionId)) {
      newActionIds.push(actionId);
    }
    if (newActionIds.includes(removedActionId)) {
      const index = newActionIds.indexOf(removedActionId);
      newActionIds.splice(index, 1);
    }
    let newTree;
    let newHandlers;
    switch (action.type) {
      case 'SET_ACTIONMAP':
        return {
          canvas,
          stage,
          tree,
          handlers,
          tweenItems,
          actionMap: newActionMap
        };
      case 'ADD_CANVAS':
        return {
          canvas: payload.canvas,
          tree: new Tree(),
          handlers,
          tweenItems,
          actionIds: newActionIds,
          actionMap
        };
      case 'ADD_STAGE':
        return {
          canvas,
          stage: payload.stage,
          tree: new Tree(),
          handlers,
          tweenItems,
          actionIds: newActionIds,
          actionMap
        };
      case 'ADD_DISPLAY_OBJECT':
        if (id && tree && tree.contains(parentId) && value instanceof Object) {
          value.type = type;
          newTree = tree.clone({ tweenItems });
          newTree.set({parentId, id, value});
          renderTree({ tree: newTree, canvas, stage, handlers, tweenItems });
          return {
            canvas,
            stage,
            tree: newTree,
            handlers,
            tweenItems,
            actionIds: newActionIds,
            actionMap
          };
        }
        break;
      case 'REMOVE_DISPLAY_OBJECT':
        if (id && tree && tree.contains(id)) {
          newTree = tree.clone({ tweenItems });
          newTree.remove(id);
          renderTree({ tree: newTree, canvas, stage, handlers, tweenItems });
          return {
            canvas,
            stage,
            tree: newTree,
            handlers,
            tweenItems,
            actionIds: newActionIds,
            actionMap
          };
        }
        break;
      case 'ADD_DISPLAY_OBJECTS':
        newTree = tree.clone({ tweenItems });
        items.forEach(item => {
          const { id, parentId, value, type } = item;
          if (id && tree && tree.contains(parentId) && value instanceof Object) {
            if (displayTypes.includes(type)) {
              value.type = type;
              newTree.set({parentId, id, value});
            }
          }
        });
        renderTree({ tree: newTree, canvas, stage, handlers, tweenItems });
        return {
          canvas,
          stage,
          tree: newTree,
          handlers,
          tweenItems,
          actionIds: newActionIds,
          actionMap
        };
      case 'ADD_HANDLER':
        if (id && tree && tree.contains(id)) {
          newTree = tree.clone({ tweenItems });
          newHandlers = handlers.concat(handler);
          renderTree({ tree: newTree, canvas, stage, handlers: newHandlers, tweenItems });
          return {
            canvas,
            stage,
            tree: newTree,
            handlers: newHandlers,
            tweenItems,
            actionIds: newActionIds,
            actionMap
          };
        }
        break;
      case 'UPDATE_TREE':
        return {
          canvas,
          stage,
          tree: updatedTree,
          handlers,
          tweenItems,
          actionIds: newActionIds,
          actionMap
        };
      case 'SEND_ACTIONID':
        return {
          canvas,
          stage,
          tree,
          handlers,
          tweenItems,
          actionIds: newActionIds,
          actionMap
        };
      case 'REMOVE_ACTIONID':
        return {
          canvas,
          stage,
          handlers,
          tweenItems,
          tree: updatedTree,
          actionIds: newActionIds,
          actionMap
        };
      case 'ADD_TWEENITEM':
      case 'REMOVE_TWEENITEM':
        return {
          canvas,
          stage,
          tree,
          handlers,
          tweenItems: newTweenItems,
          actionIds: newActionIds,
          actionMap
        };
      default:
        return state;
    }
  }
  return state;
}

function canvasReducer(state, action) {
  const { payload } = action;
  if (action.type === 'INCREMENT_ANGLE') {
    return { ...state, angle: state.angle + action.payload.angle_increment };
  } else if (action.type === 'ADD_ITEM') {
    const items = state.items.filter(item => item.id = payload.id);
    if (!items.length) {
      const index = state.items.length;
      return { items: Object.assign([], state.items, { [index]: payload.item })};
    }
    return state;
  } else if (action.type === 'UPDATE_ITEM') {
    const index = state.items.findIndex(item => item.id === payload.id);
    if (index >= 0) {
      let item = state.items[index];
      if (item.update) {
        item = item.update(payload.attributes);
        return { items: Object.assign([], state.items, { [index]: item })};
      }
    }
  } else if (action.type === 'UPDATE_ITEMS') {
    const items = Object.assign([], state.items);
    const newItems = payload.items;
    newItems && newItems.forEach(item => {
      const index = items.findIndex(i => i.id === item.id);
      items[index] = item;
    });
    return { items };
  }
  return state;
}